import * as React from 'react'

import ParallaxImg from '../../components/parallax-image'
import WaveContainer from '../../components/wave-container'

import { useDataApi } from '../../lib/utils'

import DooerLive from '../../sections/dooer-live'
import Footer from '../../sections/footer'

import AvailableReqs from './components/available-reqs'
import Departments from './components/departments'
import Features from './components/features'
import Hero from './components/hero'

import imgParallax from './career-parallax.jpg'
import Seo from '../../components/seo'

interface IJobProps {
  id: string
  links: { 'careersite-job-url': string }
  attributes: { title: string }
}

export default function Career() {
  const jobs = useDataApi<{ data?: IJobProps[] }>('/api/v1/jobs')?.data?.data || []

  return (
    <>
      <Seo
        description="När du blir en del av vårt fantastiska team får du vara med på en resa där bara du sätter gränserna."
        image="https://www.dooer.com/images/og/og_karriar.jpg"
        title="Lediga tjänster | Dooer"
        url="https://www.dooer.com/karriar"
      />

      <Hero />
      <WaveContainer>
        <AvailableReqs jobs={jobs} />
      </WaveContainer>
      <WaveContainer>
        <Features />
      </WaveContainer>
      <WaveContainer>
        <Departments />
      </WaveContainer>
      <WaveContainer>
        <ParallaxImg className="visible-md" imageSrc={imgParallax} />
      </WaveContainer>

      <DooerLive inverted />
      <Footer inverted />
    </>
  )
}
